<template>
  <div class="line_top">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'LineTopWrap'
}
</script>
